export enum MenuOption {
  Invoices = 'Invoices',
  BuyItAgain = 'Buy It Again',
  SavedCarts = 'Saved Carts',
  Lists = 'Lists',
  Subscriptions = 'Subscriptions',
  DocumentLibrary = 'Document Library',
  SoftwareLibrary = 'Software Library',
  Logout = 'Logout',
  Profile = 'Profile',
  Account = 'Account',
  Login = 'Login',
  Orders = 'Orders',
  Quotes = 'Quotes',
  PayInvoices = 'Pay Invoices',
  ProductSourcing = 'Product Sourcing',
}
